import { default as config } from './constants';

export const promoUrl = (relativeSlug) => {
	return config.PROMOTION_ENTRY_URI + "/" + relativeSlug;
}

export const validString = (val, minLength = 2, maxLength = 255, optional = false) => {
	if (optional) {
		if (val == null) {
			return true;
		}
	} else {
		if (val == null) {
			return false;
		}
	}
	if (val.length < minLength) {
		return false;
	}
	if (val.length > maxLength) {
		return false;
	}
	return true;
}

export const validPhone = (val, optional = false) => {
	if (optional) {
		if (val == null) {
			return true;
		}
	} else {
		if (val == null) {
			return false;
		}
	}
	const cnt = val.replace(/[^0-9]/g, "").length
	if (cnt > 9 && cnt < 12) {
		return true;
	}
	return false;
}

export const validAge = (obj, age=18) => {
	var dt = new Date(obj);
	if (isNaN(dt)) {
		return false;
	}

	dt = dt.setFullYear(dt.getFullYear() + age)
	var today = new Date();
	if (today > dt) {
		return true;
	}
	return false;
}


export const validEmail = (email, optional = false) => {
	if (optional) {
		if (email == null) {
			return true;
		}
	} else {
		if (email == null) {
			return false;
		}
	}

	// Taken from: @see https://stackoverflow.com/questions/46155/how-can-you-validate-an-email-address-in-javascript
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

export const validRequired = (obj) => {

	if (obj === undefined)
		return false;
	if (obj === null)
		return false;
	if (obj === false)
		return false;
	return true;
}

export const validSqFt = (obj) => {
	if (obj > 0) {
		return true
	}
	return false;
}

export const validNumAssoc = (obj) => {
	if (obj > 0) {
		return true
	}
	return false;
}

export const throttle = (func, wait) => {
	let context, args, prevArgs, argsChanged, result;
	let previous = 0;
	return function () {
		let now, remaining;
		if (wait) {
			now = Date.now();
			remaining = wait - (now - previous);
		}
		context = this;
		args = arguments;
		argsChanged = JSON.stringify(args) != JSON.stringify(prevArgs);
		prevArgs = Object.assign({}, args);
		if (argsChanged || wait && (remaining <= 0 || remaining > wait)) {
			if (wait) {
				previous = now;
			}
			result = func.apply(context, args);
			context = args = null;
		}
		return result;
	};
};


export const getOffset = (domElement) => {
	domElement = domElement.getBoundingClientRect();
	return {
		left: domElement.left + (window.scrollX || window.pageXOffset),
		top: domElement.top + (window.scrollY || window.pageYOffset)
	}
}

export const getGridLayout = (gridItem, gridPane, isActive = false) => {
	if (gridItem === undefined) return {
		pane: { left: 0, top: 0, width: 0, height: 0 },
		grid: { left: 0, top: 0, width: 0, height: 0 }
	};

	const domItem = gridItem.getBoundingClientRect();
	if (gridPane === undefined || gridPane === null) return {
		pane: { left: 0, top: 0, width: 0, height: 0 },
		grid: {
			left: domItem.left + (window.scrollX || window.pageXOffset),
			top: domItem.top + (window.scrollY || window.pageYOffset),
			width: domItem.width,
			height: domItem.width
		}
	}

	const domPane = gridPane.getBoundingClientRect();
	const spacing = 10;
	return {
		pane: { // The pane needs to reflect the size of the content we're loading
			left: domPane.left + (window.scrollX || window.pageXOffset),
			top: domPane.top + (window.scrollY || window.pageYOffset),
			width: domPane.width,
			height: domPane.height + (spacing * 2)
		},
		grid: {
			left: domItem.left + (window.scrollX || window.pageXOffset),
			top: domItem.top + (window.scrollY || window.pageYOffset),
			width: domItem.width,
			height: domItem.width + domPane.height + (spacing * 3) // times 3 to help us account for margins on elements not including the pane.
		}
	}
}

export const isFunction = (fcn) => {
	return fcn instanceof Function;
}

export const objectMap = (obj, mapFn) => {
	if (obj === 'null')  return null;
  return Object.keys(obj).reduce(function(result, key) {
    result[key] = mapFn(obj[key], key);
    return result;
  }, {});
}


// WEBPACK FOOTER //
// ./src/utils.js